import TwoFaForm from './two-fa-form';

export default TwoFaForm;
